import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Criteria/Hierarchies/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class CriteriaHierarchyQueries extends VueCqrs
{

	runCriteriaPageQueryV1(workspaceId: number, evalModelId: number)
	{
		const query = q.buildCriteriaPageQueryV1(workspaceId, evalModelId);
		this.$query(query);
	}

	runLegacyMeasurementsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildLegacyMeasurementsPageQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}

	runMeasurementsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildMeasurementsPageQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}


	runCriteriaHierarchyQueryV1(chId: number, wsId: number)
	{
		const query = q.buildCriteriaHierarchyQueryV1(chId, wsId);
		this.$query(query);
	}

	runAttributeLibraryQueryV1(chId: number, wsId: number)
	{
		const query = q.buildAttributeLibraryQueryV1(chId, wsId);
		this.$query(query);
	}

	runCriteriaLibraryQueryV1(chId: number, wsId: number)
	{
		const query = q.buildCriteriaLibraryQueryV1(chId, wsId);
		this.$query(query);
	}

	runCriterionQueryV1(wsId: number, projectId: number, chId: number, criterionId: number)
	{
		const query = q.buildCriterionQueryV1(wsId, projectId, chId, criterionId);
		this.$query(query);
	}

	runSubcriteriaQueryV1(chId: number, parentId: number,  wsId: number)
	{
		const query = q.buildSubcriteriaQueryV1(chId, parentId, wsId);
		this.$query(query);
	}

	runCriteriaHierarchyDependenciesQueryV1(workspaceId: number, chId: number)
	{
		const query = q.buildCriteriaHierarchyDependenciesQueryV1(workspaceId, chId);
		this.$query(query);
	}

	runCriterionDependenciesQueryV1(workspaceId: number, chId: number, criterionId: number)
	{
		const query = q.buildCriterionDependenciesQueryV1(workspaceId, chId, criterionId);
		this.$query(query);
	}
}
